// extracted by mini-css-extract-plugin
export default {"loadingTile":"loading-tile_loadingTile__eE2Lj"};